// «UI nuova» switch (docs/ui-nuova/MIGRATION-PLAN.md §1.1, step M9 booking; recipe
// docs/ui-nuova/briefs/M9-query-only-apps.md). Owner, 2026-10-19: booking opens on
// the classic UI and switches to the new one only through the query param. The app
// opts in QUERY-ONLY: enable({ queryOnly: true }) shows no switch anywhere (patients
// never see one, not even on the preview tenants: UI_PREVIEW_ORGS is ignored); the
// new UI applies only on a device opened with `?ui=new` (`?ui=old` locks it again)
// or, in a non-production build, with a stored choice. enable() also re-stamps
// html[data-ui] (the inline script in index.html already did it before boot, so no
// flash) and tags Sentry. The tenant of the unlock is the public organization slug,
// pushed by routes/application.js setupController (ui.setTenant): patients are
// anonymous. Never look up service:session from here: it would instantiate the real
// session before the test mocks.
export function initialize(appInstance) {
  appInstance.lookup('service:ui')?.enable({ queryOnly: true });
}

export default {
  initialize,
};
